import {useEffect, useState} from "react";

export const useRequiredFieldError = (fieldRef, isRequired) => {
    const [requiredFieldInvalid, setRequiredFieldInvalid] = useState(false);

    useEffect(() => {
        const field = fieldRef.current;

        if (!isRequired || !field) {
            setRequiredFieldInvalid(false);
            return undefined;
        }

        const syncRequiredFieldError = () => {
            setRequiredFieldInvalid(field.dataset.requiredInvalid === "true");
        };

        syncRequiredFieldError();

        if (typeof MutationObserver === "undefined") return undefined;

        const observer = new MutationObserver(syncRequiredFieldError);
        observer.observe(field, {attributes: true, attributeFilter: ["data-required-invalid"]});

        return () => observer.disconnect();
    }, [fieldRef, isRequired]);

    return requiredFieldInvalid;
};
